import { createApp } from 'vue';
import ArwToAvifConverter from '../Components/ArwToAvifConverter.vue';

const root = document.getElementById('arw-to-avif-converter');
if (root) {
  createApp(ArwToAvifConverter).mount('#arw-to-avif-converter');
}
